import axios from '../axios-marketplace';

const getList = (params) => axios.get('/admin/alertas', {
  params,
});

export default {
  getList,
};
